import 'date-fns';
import isBefore from 'date-fns/isBefore';
import isValid from 'date-fns/isValid';
import startOfDay from 'date-fns/startOfDay';
import React, {useState} from 'react';
import {isEmpty} from 'lodash/lang';
import MoreMenu from '../common/MoreMenu';
import {fetchQuizzes, prepareUsageReport} from '../../api';
import {Button, TextField, Typography} from '@material-ui/core';
import {PrimaryDarkButton} from '../common/StyledButtons';
import InputAdornment from '@material-ui/core/InputAdornment';
import {Search as SearchIcon, Loop, Mail as MailIcon} from '@material-ui/icons';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {addFlashMessage} from '../../actions/flash-message';
import {connect} from 'react-redux';
import {isEmail} from 'validator';

function UsageReportForm(props){
    const {user} = props;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    const inputRef = React.useRef(null);
    const [hideMoreMenu, setHideMoreMenu] = useState(true);
    const [quizInput, setQuizInput] = useState(null);
    const [quizzes, setQuizzes] = useState(null);
    const [errors, setErrors] = useState({});
    const [confirmed, setConfirmed] = useState(false);
    const [confirmedMessage, setConfirmedMessage] = useState(null);
    const [email, setEmail] = useState(user.email);

    const [suggestTimeout, setSuggestTimeout] = useState(null);
    const [fetchTimeout, setFetchTimeout] = useState(null);

    const resetState = () => {
        setStartDate(null);
        setEndDate(null);
        setSelectedQuiz(null);
        setQuizInput(null);
        setQuizzes(null);
        setSuggestTimeout(null);
        setFetchTimeout(null);
        setConfirmed(false);
        setEmail(user.email);
        clearTimers();
    };

    const clearTimers = () => {
        if (suggestTimeout != null){
            clearTimeout(suggestTimeout);
            setHideMoreMenu(true);
        }
        if (fetchTimeout != null) {
            clearTimeout(fetchTimeout);
        }
    };

    const handleUpdateTopicString = (e) => {
        setErrors(null);
        setSelectedQuiz(null);
        clearTimers();

        let fetchValue = e.currentTarget.value;

        setSuggestTimeout(setTimeout(() => setHideMoreMenu(false), 650));
        setQuizInput(document.querySelector('#menu-anchor'));
        setFetchTimeout(setTimeout( () => fetchAndUpdateQuizzes(fetchValue), 300));
        if (inputRef) { inputRef.current.focus(); }
    };

    const fetchAndUpdateQuizzes = (quizString) => {
        fetchQuizzes({q: quizString, perPage: 200}).then(data => setQuizzes(data.items.map((i) => {return {name: i.name, id: i._id.$oid}})));
    };

    const selectMenuItem = (e) => {
        let value = (e.currentTarget.attributes.value.value);
        inputRef.current.value = findQuizById(value)[0].name;
        setSelectedQuiz(value);
    };

    const menuItem = (option) => {
        return option.name;
    };

    const findQuizById = (id) => quizzes.filter(quiz => quiz.id === id);
    const findQuizByName = (name) => quizzes.filter(quiz => quiz.name === name);

    const handleReport = () => {
        let tempSelectedQuizId = null;
        let attemptedSelection = !isEmpty(selectedQuiz) || !isEmpty(inputRef.current.value);

        let tempErrors = {};
        let dateSelected = !!(startDate || endDate);

        if (dateSelected) {

            if (startDate && !isValid(startDate)) {
                tempErrors = {startDate: 'Start date is invalid'};
            }

            if (endDate && !isValid(endDate)) {
                tempErrors = {...tempErrors, endDate: 'End date is invalid'};
            }

            if (startDate && endDate && !isBefore(startDate, endDate)) {
                tempErrors = {...tempErrors, dateRange: 'Start date must be before end date'};
            }
        }

        if (attemptedSelection) {
            if (!isEmpty(selectedQuiz)) {
                tempSelectedQuizId = findQuizById(selectedQuiz).length === 1 ? selectedQuiz : null;
            }

            if (isEmpty(tempSelectedQuizId)) {
                let tempQuizzes = findQuizByName(inputRef.current.value);
                tempSelectedQuizId = tempQuizzes.length === 1 ? tempQuizzes[0].id : null;
            }

            if (isEmpty(tempSelectedQuizId)) {
                tempErrors = {...tempErrors, quiz: 'Invalid quiz option'};
            }
        }

        if (!isEmail(email)){
            tempErrors = {...tempErrors, email: 'Invalid email'};
        }

        if (!isEmpty(tempErrors)) {
            setErrors(tempErrors);
            return null;
        }

        else {
            //TODO: Hit the gen endpoint with the quiz id
            // and swap render to "The report will be emailed to you shortly"
            prepareUsageReport(tempSelectedQuizId, email,
                startDate ? startOfDay(startDate) : null,
                endDate ? startOfDay(endDate) : null).then((response) => {
                    setConfirmed(true);
                    setConfirmedMessage(response.message);
            }).catch(error => {
                props.addFlashMessage(`An error occurred: ${error.message}`);
            });
        }
    };

    const renderForm = () => <>
        <div>
            <TextField
                id={'email'}
                name={'email'}
                label={'Email'}
                autoComplete="off"
                variant="outlined"
                margin="dense"
                onChange={(e) => setEmail(e.target.value)}
                autoFocus={false}
                style={{width: '100%'}}
                value={email}
                error={!isEmpty(errors) && !!errors.email}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <MailIcon/>
                        </InputAdornment>
                    ),
                }}
            />
            {!isEmpty(errors) && !!errors.email && <div style={{color:'red'}}>{errors.email}</div> }
        </div>
        <div style={{margin: '8px 0 0 0'}}>
        <TextField
            id={'quiz'}
            name={'quiz'}
            label={'Quiz (Leave blank for all)'}
            autoComplete="off"
            variant="outlined"
            margin="dense"
            onChange={handleUpdateTopicString}
            inputRef={inputRef}
            autoFocus={false}
            style={{width: '100%'}}
            error={!isEmpty(errors) && !!errors.quiz}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon/>
                    </InputAdornment>
                ),
            }}
        />
        {!isEmpty(errors) && !!errors.quiz && <div style={{color:'red'}}>{errors.quiz}</div> }
        <div id="menu-anchor"/>
        <MoreMenu menuOpen={!hideMoreMenu && quizzes != null && quizzes.length !== 0}
                  menuOptions={quizzes} onClick={(e) => {setHideMoreMenu(true); selectMenuItem(e); setQuizInput(null); }}
                  anchorEl={quizInput} autoFocus={false} onClose={() => {setHideMoreMenu(true); inputRef.current.focus();}}
                  displayFunction={menuItem} keyFunction={(option) => `${option.id}`}
        />
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    disableToolbar
                    disableFuture
                    maxDate={isValid(endDate) ? endDate : new Date()}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Start Date"
                    value={startDate}
                    onChange={(start) => {setErrors(null); setStartDate(start)}}
                    error={!isEmpty(errors) && (!!errors.startDate || (!!errors.dateRange && !errors.endDate))}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    maxDateMessage={''}
                    invalidDateMessage={''}
                />
                <KeyboardDatePicker
                    disableToolbar
                    disableFuture
                    minDate={isValid(startDate) ? startDate : new Date(0)}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="End Date"
                    value={endDate}
                    onChange={(end) => {setErrors(null); setEndDate(end)}}
                    error={!isEmpty(errors) && (!!errors.startDate || (!!errors.dateRange && !errors.startDate))}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    minDateMessage={''}
                    invalidDateMessage={''}
                />
            </MuiPickersUtilsProvider>
        </div>
        {!isEmpty(errors) && !!errors.startDate && <div style={{color:'red'}}>{errors.startDate}</div> }
        {!isEmpty(errors) && !!errors.endDate && <div style={{color:'red'}}>{errors.endDate}</div> }
        {!isEmpty(errors) && !!errors.dateRange && !errors.startDate && !errors.endDate &&
        <div style={{color:'red'}}>{errors.dateRange}</div> }
        <div style={{display: 'flex', justifyContent: 'space-around', margin: '16px 0'}}>
            <PrimaryDarkButton onClick={handleReport}>Email Report</PrimaryDarkButton>
            <Button variant={'text'} color={'primary'} onClick={() => {resetState(); props.onClose();}}>Cancel</Button>
        </div> </>;

    const renderConfirmedMessage = () => <>
        <Typography align="center" color="primary" gutterBottom>
            <Loop style={{width: '6rem', height: '6rem'}}/>
        </Typography>
        <Typography variant="h5" align="center" gutterBottom>
            {confirmedMessage}
        </Typography>
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <PrimaryDarkButton onClick={() => {props.onClose(); resetState();}}>Done</PrimaryDarkButton>
        </div>
        </>;

    return confirmed ? renderConfirmedMessage() : renderForm();
}

const mapDispatchToProps = (dispatch) => ({
    addFlashMessage: (...args) => dispatch(addFlashMessage(...args)),
});

export default connect(
    ({account: {user}}) => ({
        user,
    }),
    mapDispatchToProps
)(UsageReportForm);